"use client";
import React from "react";
import "./boxstyle.css";
import HowItsWorks from "./HowItsWorks";
import { RoadmapSection } from "./RoadmapSection";
import  {TokenomicsSection}  from "./TokenomicsSection";
import  Footer  from "./Footer";
import  {ApyReferralHighlights}  from "./ApyReferralHighlights";
import { VuesaxBulkShieldTick } from "./ui/VuesaxBulkShieldTick";
import { FAQSection } from "./FAQSection";
import  StakeCalculte  from "./StakeCalculte";
import  StakingStats  from "./StakingStats";
import { Link } from "react-router-dom";

import  InviteSection  from "./InviteSection";
const StakingPage = () => {  const highlights = [
    {
      title: "14% APY",
      subtitle: "Compounded rewards on $BABYU",
    },
    {
      title: "2% Referral Bonus",
      subtitle: "Invite and earn more",
    },
    {
      title: "7-Day Unstake",
      subtitle: "Stake anytime wait 7 days unstake",
    },
  ];
  return (
<div className="relative w-full  overflow-hidden bg-transparent">
      {/* 🔆 LEFT GLOW */}

<section className="w-full py-15 px-8 md:px-10 max-md:py-16 max-md:px-4">
  <div className="max-w-[1440px] mx-auto flex items-center justify-between gap-16 max-md:flex-col-reverse">
    {/* Left Side */}
    <div className="w-1/2 max-md:w-full">
      <div className="overflow-x-auto max-w-full flex justify-start">
        <div
          dangerouslySetInnerHTML={{
            __html: `
<svg width="100%" height="39" viewBox="0 0 560 39" fill="none" xmlns="http://www.w3.org/2000/svg" class="header-icon" style="min-width:240px;max-width:100%;">
  <circle cx="16" cy="19.5" r="16" fill="url(#paint0_linear)" />
  <circle cx="16" cy="19.5" r="8" fill="#473256" />
  <text fill="url(#paint1_linear)" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="clamp(18px,5vw,32px)" font-weight="500" letter-spacing="0em">
    <tspan x="42" y="31.1364">Let the Magic Multiply!</tspan>
  </text>
  <defs>
    <linearGradient id="paint0_linear" x1="6.46305" y1="11.7963" x2="30.555" y2="11.7963" gradientUnits="userSpaceOnUse">
      <stop stop-color="#FFA8D1" />
      <stop offset="0.475962" stop-color="#C3B1FF" />
      <stop offset="1" stop-color="#AEE2FF" />
    </linearGradient>
    <linearGradient id="paint1_linear" x1="125.414" y1="10.1111" x2="536.351" y2="10.1111" gradientUnits="userSpaceOnUse">
      <stop stop-color="#FFA8D1" />
      <stop offset="0.475962" stop-color="#C3B1FF" />
      <stop offset="1" stop-color="#AEE2FF" />
    </linearGradient>
  </defs>
</svg>
`,
          }}
        />
      </div>

      <h1 className="text-[58px] font-extrabold text-white leading-[1.2] max-md:text-4xl max-md:leading-snug font-fredoka">
        Stake Your{" "}
        <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#FFA8D1] via-[#C3B1FF] to-[#AEE2FF]">
          Baby
        </span>
        <br />
        <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#FFA8D1] via-[#C3B1FF] to-[#AEE2FF]">
          Unicorn AI Token
        </span>
      </h1>

      <p className="mt-8 text-xl text-white max-w-xl leading-relaxed max-md:text-base max-md:mt-4">
        Earn passive rewards by staking your Baby Unicorn AI tokens. The longer you stake, the more sparkles you earn!
      </p>

<Link
  to="https://babyu-sale.tech/"
  className="mt-6 bg-[linear-gradient(90deg,#FF6EB3_0%,#AA81FF_47.12%,#6BC9FF_100%)] shadow-[0px_4px_16px_#ff49b8] flex gap-2.5 justify-center items-center px-8 py-5 text-2xl font-semibold tracking-wide text-white border-2 border-white border-solid min-h-16 min-w-60 rounded-[50px] max-md:w-full max-md:max-w-full max-md:text-base"
>
  <span>JOIN PRESALE</span>
  <img
    src="https://cdn.builder.io/api/v1/image/assets/TEMP/8490b493579621a21a9806eb89a7ed0f66e15b73?placeholderIfAbsent=true&apiKey=0c11d46dd7d64d7a84bf3e17dbee5689"
    className="object-contain w-[25px] max-md:w-5"
    alt="Arrow icon"
  />
</Link>
    </div>

    {/* Right Side Unicorn Image */}
    <div className="w-1/2 flex justify-center max-md:w-full">
      <img
        src="Group86.png"
        alt="Baby Unicorn"
        className="max-w-[520px] w-full"
      />
    </div>
  </div>
</section>


<section className="w-full px-4 py-12 md:py-20">
  <div className="max-w-[1344px] mx-auto flex flex-col gap-10 items-center">
    {/* Centered Gradient Heading */}
    <h2 className="text-transparent bg-clip-text bg-gradient-to-r from-[#FFA8D1] via-[#C3B1FF] to-[#AEE2FF] font-fredoka text-3xl md:text-4xl font-extrabold text-center">
      APY & Referral <span className="text-white">Highlights</span>
    </h2>

    {/* Highlight Cards */}
    <div className="flex flex-col md:flex-row flex-wrap gap-6 w-full justify-center items-center">
      {highlights.map((item, i) => (
        <div
          key={i}
          className="flex flex-col items-center text-center gap-4 p-6 bg-[#2a2540] rounded-xl w-full sm:w-[432px] md:w-[432px] div-2"
        >
          <VuesaxBulkShieldTick className="w-12 h-12 shrink-0" />
          <div className="flex flex-col gap-1">
            <h3 className="text-white text-xl md:text-2xl font-semibold font-[Baloo_2]">
              {item.title}
            </h3>
            <p className="text-neutral-100 text-sm md:text-base font-[Inter] leading-tight">
              {item.subtitle}
            </p>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>








<HowItsWorks/>




<StakeCalculte/>
    <div className="box-border flex flex-col gap-16 items-start px-5 py-0 mx-auto my-0 w-full max-w-[1344px] max-md:gap-10 max-md:px-4 max-md:py-0 max-sm:gap-8 max-sm:px-3 max-sm:py-0">
  {/* Heading and subtitle */}
  <div className="flex justify-between items-center w-full max-md:flex-col max-md:gap-8 max-md:items-start">
    <div className="text-6xl font-bold tracking-wider text-white leading-[72px] w-[522px] max-md:w-full max-md:text-5xl max-md:tracking-wide max-md:leading-[56px] max-sm:text-4xl max-sm:tracking-wide max-sm:leading-10">
      <span className="text-6xl font-bold text-white max-md:text-5xl max-sm:text-4xl font-fredoka ">
        Why Join <span className="font-fredoka text-6xl font-bold bg-clip-text max-md:text-5xl max-sm:text-4xl from-[#FFA8D1] via-[#C3B1FF] to-[#AEE2FF] text-transparent bg-clip-text bg-gradient-to-r from-[#FFA8D1] via-[#C3B1FF] to-[#AEE2FF]">
          Early?
        </span>
      </span>
    </div>
    <div className="flex gap-2.5 justify-center items-center pl-6 border-l border-solid border-l-[color:var(--border,#302843)] w-[661px] max-md:pt-5 max-md:w-full max-md:border-t max-md:border-solid max-md:border-l-[none] max-md:border-t-[color:var(--border,#302843)]">
      <div className="text-2xl leading-8 flex-[1_0_0] text-neutral-100 max-md:text-lg max-md:leading-7 max-sm:text-base max-sm:leading-6">
        Be among the first to own $BABYU and enjoy exclusive benefits — from
        early token access and bonus NFT airdrops to peace of mind with a
        fully audited contract.
      </div>
    </div>
  </div>

  {/* Responsive container: column on tablet/mobile, row on desktop */}
  <div className="flex flex-col lg:flex-row gap-16 items-center w-full max-md:gap-10">
    {/* IMAGE FIRST */}
    <div className="flex flex-1 justify-center items-center mb-8 lg:mb-0 w-full">
      <img
        src="Group 70.png"
        alt="Baby Unicorn"
        className="max-w-[520px] w-full"
      />
    </div>
    {/* BOXES - sizes unchanged */}
 <div className="flex flex-col gap-6 justify-center items-start w-[860px] max-md:w-full">
  {/* First row of boxes */}
  <div className="flex gap-6 items-center w-full max-md:flex-col max-md:gap-5">
    {/* Box 1 */}
    <div className="flex flex-col gap-4 items-start p-6 frame-11 bg-[#3a3350] rounded-xl border-2 border-solid border-[color:var(--style-222,#2D2842)] w-[406px] max-md:w-full max-md:max-w-[500px] max-sm:gap-3 max-sm:p-5">
      <div>
        <img src="Family-Friend.svg" alt="Coin Icon" width={50} height={50} />
      </div>
      <div className="w-full text-3xl font-semibold text-white max-sm:text-2xl">
        Early Access
      </div>
      <div className="w-full text-xl leading-8 text-neutral-100 max-sm:text-lg max-sm:leading-7">
        Get in before listings and price surges
      </div>
    </div>

    {/* Box 2 */}
    <div className="flex flex-col frame-11 gap-4 items-start p-6 bg-[#3a3350] rounded-xl border-2 border-solid border-[color:var(--style-222,#2D2842)] w-[406px] max-md:w-full max-md:max-w-[500px] max-sm:gap-3 max-sm:p-5">
      <div>
        <img src="Fun-ecosystem.svg" alt="Airdrop Icon" width={50} height={50} />
      </div>
      <div className="w-full text-3xl font-semibold text-white max-sm:text-2xl">
        Exclusive Airdrops
      </div>
      <div className="w-full text-xl leading-8 text-neutral-100 max-sm:text-lg max-sm:leading-7">
        Presale holders get bonus NFTs.
      </div>
    </div>
  </div>

  {/* Second row of boxes */}
  <div className="flex gap-6 items-center w-full max-md:flex-col max-md:gap-5">
    {/* Box 3 */}
    <div className="frame-11 flex flex-col gap-4 items-start p-6 bg-[#3a3350] rounded-xl border-2 border-solid border-[color:var(--style-222,#2D2842)] w-[406px] max-md:w-full max-md:max-w-[500px] max-sm:gap-3 max-sm:p-5">
      <div>
        <img src="community-driven.svg" alt="Audit Icon" width={50} height={50} />
      </div>
      <div className="w-full text-3xl font-semibold text-white max-sm:text-2xl">
        Fully Audited
      </div>
      <div className="w-full text-xl leading-8 text-neutral-100 max-sm:text-lg max-sm:leading-7">
        Security-verified smart contract.
      </div>
    </div>

    {/* Box 4 */}
    <div className="frame-11 bg-[#3a3350] flex flex-col gap-4 items-start p-6 rounded-xl border-2 border-solid border-[color:var(--style-222,#2D2842)] w-[406px] max-md:w-full max-md:max-w-[500px] max-sm:gap-3 max-sm:p-5">
      <div>
        <img src="sequre-transparent.svg" alt="Shield Icon" width={50} height={50} />
      </div>
      <div className="w-full text-3xl font-semibold text-white max-sm:text-2xl">
        Community Powered
      </div>
      <div className="w-full text-xl leading-8 text-neutral-100 max-sm:text-lg max-sm:leading-7">
        Your voice shapes the future.
      </div>
    </div>
  </div>
</div>

  </div>
</div>


<StakingStats/>








 <InviteSection />
 <FAQSection/>
        <Footer />

    </div>
  );
};

export default StakingPage;
